import { packCriteria } from '@/utils/filters'
import { request } from '@/utils/request'
import { createScreener } from '@/utils/screener'

export function getExecutive(id, track) {
    const params = {
        track,
    }
    return request.get(`/api/executives/${id}`, params)
}

export function getExecutiveSummary(id) {
    return request.get(`/api/executives/${id}/summary`)
}

export async function searchExecutives(criteria, limit = -1, offset = 0, abort) {
    const response = await request.post(
        '/api/executives/search',
        {
            criteria: packCriteria(criteria),
            limit,
            offset,
        },
        { abort }
    )

    if (response.ok) {
        return response.content
    }

    throw response
}

export async function listExecutiveFacets() {
    const content = await searchExecutives([], 0, 0)
    return content.facets
}

export function getExecutiveAlpha(id, startDate = null, endDate = null) {
    return request.get(`/api/executives/${id}/alpha`, { startDate, endDate })
}

export default {
    get: getExecutive,
    getSummary: getExecutiveSummary,
    listFacets: listExecutiveFacets,
    search: searchExecutives,
    getAlpha: getExecutiveAlpha,
}

async function screenExecutives(criteria, page, sort, facets, signal) {
    const response = await request.post(
        '/api/executives/search',
        {
            criteria: packCriteria(criteria),
            facets,
            ...page,
            sortField: sort?.field ?? null,
            sortDirection: sort?.direction ?? null,
        },
        { signal }
    )

    if (response.ok) {
        return response.content
    }

    throw response
}

export function createExecutivesScreener(options = {}) {
    return createScreener(screenExecutives, 'results', options)
}
